import React from "react";
import TicketsToReviewPanel from "../TicketsToReviewPanel";

const TicketItem = () => {
  return (
    <div>
      <div>
        <hr />
        <div>reported ticket image or content</div>
        <div>
          <TicketsToReviewPanel />
        </div>
        <hr />
      </div>
    </div>
  );
};

export default TicketItem;
